import { get, find, filter, chain, toArray } from 'lodash';
import { createSelector } from 'reselect';
import sortPosts from '../services/sort-posts';

export const getPostMap = state => state.posts;

export const getPost = (state, postId) => getPostMap(state)[postId];

const getCategoryId = (state, categoryId) => {
  return categoryId;
};

const getEntityIdsByPage = (state, id, page) => {
  return state.pagination.posts.entitiesByPage[page] || [];
};

const getSlug = (state, slug) => {
  return slug;
};

const getOwnerId = (state, ownerId) => ownerId;
const getSiteMemberId = (state, siteMemberId) => siteMemberId;

export const getPostBySlug = createSelector([getPostMap, getSlug], (posts, slug) => find(posts, ['slug', slug]));
export const getSortedPostsByCategoryId = createSelector([getPostMap, getCategoryId], (posts, categoryId) =>
  sortPosts(filter(posts, post => post.categoryId === categoryId))
);

export const getPostsByCategoryIdAndPage = createSelector(
  [getPostMap, getCategoryId, getEntityIdsByPage],
  (posts, categoryId, entityIds) =>
    chain(entityIds).map(id => posts[id]).filter(post => post.categoryId === categoryId).value()
);

export const getSortedPostsByOwnerId = createSelector([getPostMap, getOwnerId], (posts, ownerId) =>
  sortPosts(filter(posts, post => post.ownerId === ownerId))
);

export const getSortedPosts = createSelector([getPostMap], posts => sortPosts(toArray(posts)));

export const getPostsCountByOwnerId = createSelector(
  [getPostMap, getOwnerId],
  (posts, ownerId) => filter(posts, post => post.ownerId === ownerId).length
);

export const getSortedPostsBySiteMemberId = createSelector([getPostMap, getSiteMemberId], (posts, siteMemberId) =>
  sortPosts(sortPosts(filter(posts, post => get(post, 'owner.siteMemberId') === siteMemberId)))
);


export const getPostsByOwnerIdAndPage = createSelector(
  [getPostMap, getOwnerId, getEntityIdsByPage],
  (posts, ownerId, entityIds) => chain(entityIds).map(id => posts[id]).filter(post => post.ownerId === ownerId).value()
);



// WEBPACK FOOTER //
// ./app/selectors/post-selectors.js